import { getAuth } from 'firebase/auth';

// Session-exchange payload read from the user Firebase has already signed in.
// getIdToken() re-mints the token when it expired, so a retry never ships a
// stale one and no secret has to be parked in component state.
export async function getCurrentUserTokens() {
  const user = getAuth().currentUser;
  if (!user) {
    throw new Error('No signed-in user to build the session payload from');
  }
  return { idToken: await user.getIdToken(), refreshToken: user.refreshToken };
}
